import { HugeiconsIcon } from '@hugeicons/react'
import { AlertCircleIcon, Refresh01Icon } from '@hugeicons/core-free-icons'

import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface ErrorDisplayProps {
  error: Error | null
  title?: string
  variant?: 'inline' | 'card'
  onRetry?: () => void
  isRetrying?: boolean
  className?: string
}

export function ErrorDisplay({
  error,
  title = 'Something went wrong',
  variant = 'inline',
  onRetry,
  isRetrying = false,
  className,
}: ErrorDisplayProps) {
  if (variant === 'card') {
    return (
      <Card className={cn('border-destructive', className)}>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-destructive">
            <HugeiconsIcon icon={AlertCircleIcon} className="h-4 w-4" />
            {title}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <CardDescription className="mb-4">
            {error?.message || 'Please try again.'}
          </CardDescription>
          {onRetry && (
            <Button
              variant="outline"
              size="sm"
              onClick={onRetry}
              disabled={isRetrying}
            >
              <HugeiconsIcon
                icon={Refresh01Icon}
                className={cn('h-4 w-4 mr-2', isRetrying && 'animate-spin')}
              />
              Retry
            </Button>
          )}
        </CardContent>
      </Card>
    )
  }

  return (
    <div
      className={cn(
        'flex items-center gap-2 text-sm text-destructive',
        className,
      )}
    >
      <HugeiconsIcon icon={AlertCircleIcon} className="h-4 w-4 shrink-0" />
      <p>
        {title}: {error?.message}
      </p>
    </div>
  )
}
